
import React from 'react';
import { useParams } from 'react-router-dom';
import { useGetRecord } from 'root/admin/components/hooks';
import { Title } from 'root/admin/components';
import { Form, Field, Loader, Row, Button, Popconfirm } from '@smartplatform/ui';
import store from '../../store';

const SubscriptionEdit = ({ rootPath }) => {
	const { id } = useParams();
	const record = useGetRecord({ model: 'Subscription', id });

	if (!record) {
		return <Loader />;
	};

	if (!record.lastSendAt) {
		record.lastSendAt = new Date()
	};

	const onBeforeSave = () => {
		record.name = record.name && record.name.trim();
	};

	const onDelete = () => {
		store.ui.setNotification({ message: 'Запись удалена' });
		store.history.push(rootPath + '/subscriptions');
	};

	const onError = (e) => {
		if (e) {
		const error = e.details.messages.name || e.message;
		store.ui.setNotification({ message: error , error })
		};
	};

	return (
		<div>
			<Title record={record} name='Подписчики' />
			<Form record={record} rootPath={rootPath} onDelete={onDelete} beforeSave={onBeforeSave} onError={onError} >
				<Field property='name' label='E-mail подписчика' />
				<h3>Подписки</h3>
				<Row>
					<Field property='news' label='Новости' />
					<Field property='direct-speech' label='Прямая речь' />
					<Field property='video' label='Видео' />
					<Field property='photo' label='Фото' />
				</Row>
			</Form>
		</div>
	);
};

export default SubscriptionEdit;
